<div style="display: flex; justify-content: center; align-items: center; height: 100vh; font-size: 18px;">
  <p>Completando autenticación con Microsoft...</p>
</div>

